exports.components = {
  "component---src-fragments-post-detail-index-tsx": () => import("./../../../src/fragments/post/detail/index.tsx" /* webpackChunkName: "component---src-fragments-post-detail-index-tsx" */),
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-post-index-tsx": () => import("./../../../src/pages/post/index.tsx" /* webpackChunkName: "component---src-pages-post-index-tsx" */)
}

